import { Plugin, PluginKey } from "prosemirror-state";
import MenuElement from "./menu-element";

export const menuPluginKey = new PluginKey("menu");

export const menuPlugin = (editorType) => {
  return new Plugin({
    key: menuPluginKey,
    state: {
      init() {
        return { currentActiveView: null, currentTool: null };
      },
      apply(tr, value) {
        const metaValue = tr.getMeta(menuPluginKey);

        if(!metaValue) {
          return { currentActiveView: value.currentActiveView };//value;
        }

        if(metaValue.action === "viewChange") {
          return { currentActiveView: metaValue.view };
        }
        
        if(metaValue.action === "toolChange") {
          return { currentActiveView: value.currentActiveView, currentTool: metaValue.tool };
        }

        return value;
      }
    },
    view(editorView) { return new MenuElement(editorView, editorType); },
  });
}
